export default __webpack_public_path__ + "images/AA.7a59444.png";